﻿import $ from 'jquery';
import Modal from "../modal";
import _ from 'underscore';
import { HandlerFactory } from "./handlerFactory"

declare global {
  interface JQuery {
    remote(options?: IRemoteOptions);
  }
}

export class Remote {
  public static get triggerWireup() {
    return '[data-remote][data-remote-trigger]';
  }
  private static DEFAULTS: IRemoteOptions = {
    async: true,
    beforeRemote: null,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    data: null,
    dataFilter: null,
    error: null,
    state: null,
    success: null,
    processData: true,
    traditional: false,
    type: null,
    url: null
  };

  public static execute($element: JQuery, options: IRemoteOptions): void {
    let handlers = new HandlerFactory().create();
    let _options = $.extend({}, this.DEFAULTS, options);
    try {
      for (var i = 0; i < handlers.length; i++) {
        var isHandled = handlers[i].handle($element, _options);
        if (isHandled)
          break;
      }
    }
    catch (ex) {
      Modal.openErrorModal(ex.message);
    }
  }
   public static wireupDocument: Function = _.once(() => {
    $.fn.remote = function (options) {
      $(this).each(function () {
        Remote.execute($(this), options);
      });
      return $(this);
    }

    function callRemote(e: JQueryEventObject) {
      $.fn.remote.call(this,
        {
          $element: $(this),
          $target: $(e.target),
          $triggeringEvent: e,
        } as IRemoteOptions);
    }

    $(document).on('click.rustig.remote', '[data-remote]:not(select, form, [data-remote-trigger])', callRemote);
    $(document).on('change.rustig.remote', 'select[data-remote]:not([data-remote-trigger])', callRemote);
  });

  public static wireupTriggers(): void {
    $(this).each(function () {
      let $element = $(this);
      let trigger = $element.data('remote-trigger');
      let context = $element.data('remote-trigger-context') || 'element';
      let $contextElement:any = $element;

      if (context == 'document')
        $contextElement = $(document);
      else if (context != 'element') {
        $contextElement = $(context);
        if ($contextElement.length == 0)
          throw Error('Could not find trigger context element for remote: "' + context);
      }

      $contextElement.on(trigger, function () {
        $element.remote();
      });
    });
  }
}

export interface IRemoteHandler {
  handle($element: JQuery, options?: IRemoteOptions): boolean;
}

export interface IRemoteOptions {
  async?: boolean;
  beforeRemote?(): void;
  contentType?: any;
  data?: any;
  dataFilter?(data: any, state: any): any;
  error?(jqXHR: JQueryXHR, textStatus: string, errorThrown: string): any;
  state?: any;
  success?(data: any, textStatus: string, jqXHR: JQueryXHR): any;
  traditional?: boolean;
  processData?: boolean;
  type?: string;
  url?: string;
  allowMultipleAjaxCalls?: boolean;
  $element?: JQuery;
  $target?: JQuery;
  $triggeringEvent?: JQueryEventObject;
}

